function Textarea_form_element(element) {
  this.$element = $(element);

  this.tinyMceMinHeight = 350;

  this.data = {
    id: 'id',
    richtextOption: 'richtext-option',
    internalLinks: 'internal-links'
  };

  this.init = function () {
    this.dataID = this.$element.data(this.data.id);
    this.dataRichtextOption = this.$element.data(this.data.richtextOption);
    this.dataInternalLinks = this.$element.data(this.data.internalLinks);

    // console.log('this.dataRichtextOption', this.dataRichtextOption);
    // console.log('this.dataInternalLinks', this.dataInternalLinks);

    if (this.dataRichtextOption !== undefined) {
      tinymce.remove("#" + this.dataID);
      tinymce.init({
        selector: "#" + this.dataID,
        branding: false,
        elementpath: false,
        language: "de",
        menubar: false,
        statusbar: true,
        resize: true,
        min_height: this.tinyMceMinHeight,
        entity_encoding: "raw",
        extended_valid_elements: "script[src|type],link[href|type|rel]",
        theme: "modern",
        plugins: ["paste", "code", "nonbreaking", "link", "lists", "table", "textcolor"],
        link_list: this.dataInternalLinks,
        relative_urls: false,
        toolbar: this.dataRichtextOption,
        style_formats: [{
            title: "Hochgestellt",
            inline: "sup"
          },
          {
            title: "Tiefgestellt",
            inline: "sub"
          }
        ]
      }).then((tinymceInstance) => {
        // console.log('tinymceInstance', tinymceInstance);
        // auto resize richtext height in popups
        if (this.$element[0].offsetParent && this.$element[0].offsetParent.id != '') { // if is in popup
          const i4PopupInstance = i4_Popup.get(this.$element[0].offsetParent.id);
          // i4PopupInstance.layout.height NOT exact -> use jQuery to get height
          const originalPopupHeight = $('#' + this.$element[0].offsetParent.id)[0].offsetHeight;
          const newTinyMceHeight = $(window).height() - originalPopupHeight + this.tinyMceMinHeight - 2 * 20;
          if (tinymceInstance.length > 0) {
            tinymceInstance[0].theme.resizeTo(null, newTinyMceHeight);
            i4PopupInstance.renew_size(i4PopupInstance.layout.width, i4PopupInstance.layout.height + (newTinyMceHeight - this.tinyMceHeight));
            i4PopupInstance.move(20, i4PopupInstance.layout.left);
          }
        }
      });
    }
  };
}
